import { CheckCircle } from 'phosphor-react'
import { Controller, useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'

import { Button } from '../../../../components/Button'
import { DialogModal } from '../../../../components/DialogModal'
import { Checkbox } from '../../../../components/FormElements/Checkbox'
import { useAuth } from '../../../../contexts/AuthContext'
import { useExpertCreateMutation } from '../../../../services/hooks/experts/mutations/useExpertCreateMutation'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const TermsStep = () => {
  const { control, formState, getValues, handleSubmit, reset } =
    useFormContext()
  const { mutate, isSuccess, isLoading } = useExpertCreateMutation()
  const { formatMessage } = useIntl()
  const { signIn } = useAuth()
  const navigate = useNavigate()

  const onCreateExpert = (data: any) => {
    mutate(data)
  }

  const onAuthUser = async () => {
    const credentials = {
      email: getValues('email'),
      password: getValues('password'),
    }

    await signIn(credentials)
  }

  useEffect(() => {
    if (!getValues('email') || !getValues('password')) {
      reset()
      navigate('/expert/register')
    }
  }, [])

  return (
    <div className="flex flex-col grow">
      <section className="flex flex-col grow px-8 pt-14 pb-10 text-black overflow-scroll text-justify max-h-[calc(100vh_-_239px)] md:max-h-full md:overflow-auto">
        <h1 className="font-openSans mb-16 text-[40px] font-bold text-[#001D2F] uppercase mx-auto text-center">
          {formatMessage({ id: 'TRUST_INSIGHT_TERMS_OF_PARTICIPATION' })}
        </h1>

        <div className="whitespace-pre-line text-base font-medium text-[#39393A]">
          <h2
            id="TERMS_OF_PARTICIPATION_SUBTITLE_1"
            className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]"
          >
            {formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_1' })}
          </h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_1' })}</span>

          <h2
            id="TERMS_OF_PARTICIPATION_SUBTITLE_2"
            className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]"
          >
            {formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_2' })}
          </h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_2' })}</span>

          <h2
            id="TERMS_OF_PARTICIPATION_SUBTITLE_3"
            className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]"
          >
            {formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_3' })}
          </h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_3' })}</span>

          <h2
            id="TERMS_OF_PARTICIPATION_SUBTITLE_4"
            className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]"
          >
            {formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_4' })}
          </h2>
          <span>
            {formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_4_A' })}
          </span>

          <ul className="list-disc list-inside mt-6 mb-6">
            <li>
              <span>
                {formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_4_B' })}
              </span>
            </li>
            <li>
              <span>
                {formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_4_C' })}
              </span>
            </li>
            <li>
              <span>
                {formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_4_D' })}
              </span>
            </li>
            <li>
              <span>
                {formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_4_E' })}
              </span>
            </li>
            <li>
              <span>
                {formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_4_F' })}
              </span>
            </li>
          </ul>

          <span>
            {formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_4_G' })}
          </span>

          <h2
            id="TERMS_OF_PARTICIPATION_SUBTITLE_5"
            className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]"
          >
            {formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_5' })}
          </h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_5' })}</span>

          <h2
            id="TERMS_OF_PARTICIPATION_SUBTITLE_6"
            className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]"
          >
            {formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_6' })}
          </h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_6' })}</span>

          <h2
            id="TERMS_OF_PARTICIPATION_SUBTITLE_7"
            className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]"
          >
            {formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_7' })}
          </h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_7' })}</span>

          <h2
            id="TERMS_OF_PARTICIPATION_SUBTITLE_8"
            className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]"
          >
            {formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_8' })}
          </h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_8' })}</span>

          <h2
            id="TERMS_OF_PARTICIPATION_SUBTITLE_9"
            className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]"
          >
            {formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_9' })}
          </h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_9' })}</span>

          <h2
            id="TERMS_OF_PARTICIPATION_SUBTITLE_10"
            className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]"
          >
            {formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_10' })}
          </h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_10' })}</span>

          <h2
            id="TERMS_OF_PARTICIPATION_SUBTITLE_11"
            className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]"
          >
            {formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_11' })}
          </h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_11' })}</span>

          <h2
            id="TERMS_OF_PARTICIPATION_SUBTITLE_12"
            className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]"
          >
            {formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_12' })}
          </h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_12' })}</span>

          <h2
            id="TERMS_OF_PARTICIPATION_SUBTITLE_13"
            className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]"
          >
            {formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_13' })}
          </h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_13' })}</span>

          <h2
            id="TERMS_OF_PARTICIPATION_SUBTITLE_14"
            className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]"
          >
            {formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_14' })}
          </h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_14' })}</span>

          <h2
            id="TERMS_OF_PARTICIPATION_SUBTITLE_15"
            className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]"
          >
            {formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_15' })}
          </h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_15' })}</span>

          <h2
            id="TERMS_OF_PARTICIPATION_SUBTITLE_16"
            className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]"
          >
            {formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_16' })}
          </h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_16' })}</span>
        </div>
      </section>

      <form
        onSubmit={handleSubmit(onCreateExpert)}
        className="flex flex-col md:h-auto md:pb-20 md:mt-20 mt-[10px] text-black px-10 md:static relative before:content-[''] md:before:static before:absolute before:top-[-82px] before:left-0 before:w-full md:before:h-0 before:h-[4.5rem] before:bg-gradient-to-t from-white to-transparent"
      >
        <div className="mb-10">
          <Controller
            name="terms"
            control={control}
            defaultValue={false}
            render={({ field: { value, onChange } }) => (
              <Checkbox
                label={formatMessage({ id: 'READ_AND_ACCEPT_THE_TERMS' })}
                checked={value}
                onChange={onChange}
              />
            )}
          />
        </div>

        <footer className="md:w-96 md:mx-auto">
          <Button
            disabled={!formState.isValid}
            isLoading={isLoading}
            type="submit"
            fullWidth
          >
            {formatMessage({ id: 'CONCLUDE' })}
          </Button>
        </footer>
      </form>

      <DialogModal isOpen={isSuccess}>
        <div className="p-6 pt-0">
          <CheckCircle size={72} className="mx-auto mb-4 text-primary-light" />
          <strong className="block font-normal text-center mb-14">
            {formatMessage({ id: 'SUCCESSFULLY_ACCEPTED_TERMS' })}
          </strong>
          <Button fullWidth type="button" onClick={onAuthUser}>
            {formatMessage({ id: 'CONTINUE' })}
          </Button>
        </div>
      </DialogModal>
    </div>
  )
}
